export const  phoneExpression:string |undefined  =process.env.REACT_APP_PHONE_REG_EXP
export const  postalCodeExpression:string|undefined  =process.env.REACT_APP_POSTAL_CODE_REG_EXP
export const  sortCodeExpression:string|undefined =process.env.REACT_APP_SORT_CODE_REG_EXP
export const  bankAccountExpression:string|undefined =process.env.REACT_APP_BANK_ACCOUNT_REG_EXP
export const  pdiNumberExpression:string|undefined=process.env.REACT_APP_PDI_NUMBER_REG_EXP
